import { useEffect, useState } from 'react';

import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';

import { CategoryFormModalProps } from './types';

const MAX_NAME_LENGTH = 100;

/**
 * Modal for creating or renaming a savings category — a single validated name field.
 */
function CategoryFormModal({
  isOpen,
  title,
  initialName = '',
  isSaving,
  onClose,
  onSubmit,
}: CategoryFormModalProps) {
  const [name, setName] = useState(initialName);

  useEffect(() => {
    if (isOpen) {
      setName(initialName);
    }
  }, [isOpen, initialName]);

  const trimmedName = name.trim();
  const isValid = trimmedName.length > 0 && trimmedName.length <= MAX_NAME_LENGTH;

  const handleSubmit = () => {
    if (isValid) {
      onSubmit(trimmedName);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel>Name</FormLabel>
            <Input
              value={name}
              maxLength={MAX_NAME_LENGTH}
              placeholder="e.g. Holidays"
              onChange={(event) => setName(event.target.value)}
              data-testid="category-name-input"
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr="12px" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} isDisabled={!isValid} isLoading={isSaving}>
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default CategoryFormModal;
